module.exports = __webpack_public_path__ + "static/img/blank.891ea86.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/blank.jpg
// module id = 908x
// module chunks = 1